module.exports = __webpack_public_path__ + "653d1b670b9ff8c5970ece0243e60ba0.jpg";